import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventDetails } from '../../../shared/models/event';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { IroleProcessActivity } from 'src/app/shared/models/activity';
import { environment } from 'src/environments/environment.prod';
import {
  CandidateBasicDetails,
  SchedulerCandidate,
  ActivitiesOnCandidate,
} from 'src/app/shared/models/schedulerAssociate';

import { CandidateStatusModel } from '../models/candidateStatusModel';

// import { Status } from 'src/app/shared/models/operations_persona';

@Injectable({
  providedIn: 'root',
})
export class AssociateService {
  activityUrl: string = environment.activityUrl;
  baseUrl: string = environment.eventUrl;
  offerDbUrl: string = environment.offerDBUrl;
  candidateActivityUrl: string = environment.eventCandidateDataUrl;
  dashboardCandidateListUrl = environment.dashboardCandidateListUrl;
  schedulerDashboardUrl: string = environment.schedulerDashboardUrl;
  recruiter: string = environment.recruiterUrl;
  offerTest: string = environment.offerTest;
  genericApi: string = environment.genericApiUrl;
  companyHiringType: number = parseInt(localStorage.getItem('fresherCompHiringTypeId'));
  constructor(private http: HttpClient) {}

  getEventDetails(): Observable<EventDetails[]> {
    return this.http.get<EventDetails[]>(
      this.baseUrl +
        'events/getEventDetails?companyHiringTypeId=' +
        this.companyHiringType +
        '&status=ACTIVE&eventsOf=PAST',
    );
  }
  getSchedulerLatestStats(eventId: number): Observable<any> {
    // let evntId = {
    //   "eventId":eventId?eventId:5
    // }
    return this.http.post<any>(this.offerDbUrl + 'getDashboardNumbers?eventId=' + eventId, '');
  }
  getActivities(): Observable<any> {
    const options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    const body = {
      roleCode: 'Offer_DEO',
      companyHiringTypeId: this.companyHiringType,
      appCode: 'InTap',
      isLoginUser: 'yes',
    };
    // return this.http.get<activity[]>(this.activityUrl+"getActivities?processId="+processId);
    // return this.http.get<activity[]>('assets/json/roleProcessActivity.json');
    return this.http.post<IroleProcessActivity[]>(
      this.activityUrl + 'activity/getRolesActivitiesProcesses',
      body,
      options,
    );
  }
  getDashboardData() {
    return this.http.get<any>(this.activityUrl + 'getAllApplicants?tenantId=1');
  }

  getCandidateListByIds(applicationIds): Observable<SchedulerCandidate[]> {
    return this.http.post<SchedulerCandidate[]>(
      this.dashboardCandidateListUrl + 'candidate/getAllCandidates',
      applicationIds,
    );
  }

  getCandidateBasicDetails(applicationId: any, candidateId: any): Observable<CandidateBasicDetails> {
    return this.http.get<CandidateBasicDetails>(
      this.schedulerDashboardUrl +
        'candidate/getBasicCandidateDetails?candidateId=' +
        candidateId +
        '&applicationId=' +
        applicationId,
    );
  }

  getCandidateEvents(appId, candidateId): Observable<any> {
    return this.http.get<any>(
      this.candidateActivityUrl + 'getCandidateActivities?applicationId=' + appId + '&candidateId=' + candidateId,
    );
  }

  getCandidateStatus(): Observable<CandidateStatusModel[]> {
    return this.http.get<any>(this.offerDbUrl + '/getdropdown?objRefType=OF');
  }

  getFilteredDateEvent(currentDate) {
    return this.http.get<any>(
      this.baseUrl +
        'events/getEventDetails?companyHiringTypeId=' +
        this.companyHiringType +
        '&eventDate=' +
        currentDate,
    );
  }

  getEventClearDate() {
    return this.http.get<any>(
      this.baseUrl +
        'events/getEventDetails?companyHiringTypeId=' +
        this.companyHiringType +
        '&status=ACTIVE&eventsOf=PAST',
    );
  }
  getActivitiesOnCandidate(applicationId: any, candidateId: any): Observable<ActivitiesOnCandidate> {
    return this.http.get<ActivitiesOnCandidate>(
      this.candidateActivityUrl +
        'getCandidateActivities?applicationId=' +
        applicationId +
        '&candidateId=' +
        candidateId,
    );
  }
  postUniversity(data) {
    return this.http.post<any>(this.schedulerDashboardUrl + 'Details/saveuniversityDetails', data);
  }
  postOrganization(data) {
    return this.http.post<any>(this.schedulerDashboardUrl + 'Details/saveOrganizationDetails', data);
  }
  postInstitute(data) {
    return this.http.post<any>(this.schedulerDashboardUrl + 'Details/saveinstituteDetails', data);
  }
  getCities(data) {
    return this.http.get<any>(this.recruiter + 'Events/getcityDetails/' + data);
  }
  getStates(value) {
    return this.http.get<any>(this.genericApi + 'Details/getAllStates/' + value);
  }
  getCountry() {
    return this.http.get<any>(this.offerTest + 'modules/getCountry');
  }
  getEducationType() {
    return this.http.get<any>(this.genericApi + 'Details/getEducationType');
  }
  postEducation(data) {
    return this.http.post<any>(this.genericApi + 'Details/saveEducationDetails', data);
  }
  postSpecialization(data) {
    return this.http.post<any>(this.genericApi + 'Details/saveSpecializationDetails', data);
  }
  postCity(data) {
    return this.http.post<any>(this.genericApi + 'Details/savecityDetails', data);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AssociateResolverService {
  constructor(private associateApi: AssociateService) {}
  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.associateApi.getEventDetails();
  }
}
